export const headerTokens = {
  'header-height': '56px',
  'header-bg': 'var(--dp-color-background)',
  'header-border-color': 'var(--dp-color-border)',
  'header-border-width': '1px',
  'header-padding-x': 'var(--dp-spacing-lg)',
  'header-title-font-size': 'var(--dp-font-size-xl)',
  'header-title-font-weight': 'var(--dp-font-weight-bold)',
  'header-subtitle-font-size': 'var(--dp-font-size-sm)',
  'header-subtitle-color': 'var(--dp-color-text-secondary)',
} as const;
